// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c37558fd","703":"21489f3f"}[chunkId] + ".chunk.js";
};